var React = require('react');

function Heroku (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h2500v2500H0z","fill":"#6762a5","key":0}),React.createElement("path",{"d":"M1417.5 1969.9v-787.4s51.2-188.4-630.9 77.1c-1.2 3.4-1.2-728.2-1.2-728.2l222.9-1.4v468.7s624-245.8 624 186.4v784.8zm127-1156.2h-236.4c85.1-104 162.1-282.3 162.1-282.3h244.4c.1 0-41.8 116.2-170.1 282.3zM789.4 1968.6v-448.4l224.2 224.2z","fill":"#fff","key":1})]);
}

Heroku.defaultProps = {"viewBox":"0 0 2500 2500","width":"2500","height":"2500"};

module.exports = Heroku;

Heroku.default = Heroku;
